import englishMessages from 'ra-language-english';

export default {
  ...englishMessages,

  resources: {
  },
};
